function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "question",
  d: "M9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75Z",
  stroke: "black",
  strokeWidth: 1.125,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "question",
  d: "M9 13.5C9.46599 13.5 9.84375 13.1222 9.84375 12.6562C9.84375 12.1903 9.46599 11.8125 9 11.8125C8.53401 11.8125 8.15625 12.1903 8.15625 12.6562C8.15625 13.1222 8.53401 13.5 9 13.5Z",
  fill: "black"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "question",
  d: "M9 10.125V9.5625C9.38938 9.5625 9.77002 9.44704 10.0938 9.23071C10.4175 9.01438 10.6699 8.7069 10.8189 8.34716C10.9679 7.98742 11.0069 7.59157 10.9309 7.20967C10.855 6.82777 10.6675 6.47697 10.3921 6.20163C10.1168 5.9263 9.76598 5.73879 9.38408 5.66283C9.00218 5.58687 8.60633 5.62585 8.24659 5.77486C7.88685 5.92387 7.57937 6.17621 7.36304 6.49997C7.14672 6.82373 7.03125 7.20437 7.03125 7.59375",
  stroke: "black",
  strokeWidth: 1.125,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgQuestionRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionRound);
export default __webpack_public_path__ + "static/media/question-round.07cc94af.svg";
export { ForwardRef as ReactComponent };